
import React from 'react';
import { Button } from '@/components/ui/button';
import { Languages } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  
  const toggleLanguage = () => {
    setLanguage(language === 'ur' ? 'en' : 'ur');
  };
  
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleLanguage}
      className={`flex items-center gap-2 transition-all duration-300 bg-gradient-to-r ${
        language === 'ur' 
          ? 'from-blue-50 to-blue-100 text-blue-700 hover:from-blue-100 hover:to-blue-200' 
          : 'from-indigo-50 to-indigo-100 text-indigo-700 hover:from-indigo-100 hover:to-indigo-200'
      } border-2 ${
        language === 'ur' ? 'border-blue-300' : 'border-indigo-300'
      } shadow-sm`}
      aria-label="Switch language"
    >
      <Languages size={16} className={language === 'ur' ? 'ml-0.5' : 'mr-0.5'} />
      <span className={language === 'ur' ? 'font-medium' : ''}>
        {language === 'ur' ? 'English' : 'اردو'}
      </span>
    </Button>
  );
};

export default LanguageSwitcher;
